export const profileRoute = {
    path: "/me/profile",
    name: "me-profile",
    component: () => import("@/ui/me/profile.vue")
  };